import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import databaseService from '../../api/databaseService'

const initialState = {
  databaseInfo: null,
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: '',
}

// Fetch database details by database name
export const fetchDatabaseDetails = createAsyncThunk(
  'database/fetchDetails',
  async (databaseName, thunkAPI) => {
    try {
      return await databaseService.getDatabaseDetails(databaseName)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const databaseSlice = createSlice({
  name: 'database',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = false
      state.message = ''
    },
    clearDatabaseInfo: (state) => {
      state.databaseInfo = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDatabaseDetails.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchDatabaseDetails.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.databaseInfo = action.payload
      })
      .addCase(fetchDatabaseDetails.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset, clearDatabaseInfo } = databaseSlice.actions
export default databaseSlice.reducer
